import { GoogleTagManager } from '@iwoca/frontend-tracking-library';

import { fetchQualifiedLeadType } from '../../lendingApi/apiQueries';
import logger from '../../utils/logger';

export const trackLeadQuality = async () => {
  const qualifiedLeadTypeResponse = await fetchQualifiedLeadType();

  if (qualifiedLeadTypeResponse) {
    try {
      GoogleTagManager.trackEvent({
        category: 'Signup',
        event: 'Track Lead Value v2',
        label: qualifiedLeadTypeResponse.data?.qualified_lead_type,
      });

      qualifiedLeadTypeResponse.data?.qualified_lead_frameworks?.forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (framework: any) => {
          GoogleTagManager.trackEvent({
            category: 'Signup',
            event: `Track QLF Value ${Object.keys(framework)[0]}`,
            label: framework[`${Object.keys(framework)[0]}`],
          });
        },
      );
    } catch (error) {
      logger.error('Failed to add Lead Value to data layer', {
        error: error,
      });
    }
  }
};
